import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {PredictionsWidgetState} from "./models/predictions-widget.state";
import {PredictionsWidgetConfig} from "./predictions-widget.config";

export class PredictionsWidgetStore extends BaseMobxStore {
  static injectables = [PredictionsWidgetConfig, PredictionsWidgetState];
}

